// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__h17zC","col":"styles_col__2npsf"};